module.exports = __webpack_public_path__ + "images/4-ru.jpg?v=898896f1ec8c89e29f67ed91fee54813";